import { useSelector } from 'react-redux';
import { RETAIL_PRICE_COLUMN, UNIT_PRICE_COLUMN } from '../constants/pricings';
import { SUPPLIER } from '../constants/roles';

const retailerTypes = {
  OPERATOR: 'operator',
  RETAILER: 'retailer',
};

const orderTypes = {
  DROPSHIP: 'dropship',
  MARKETPLACE: 'marketplace',
};

export function useRetailerType() {
  const { currentRole, supplier } = useSelector((state) => state.role);
  const {
    current: { retailer },
  } = useSelector((state) => state.retailer);
  const { supplierRetailer: supplierRetailerFromActivation } = useSelector((state) => state.activation);

  let supplierRetailer = supplierRetailerFromActivation;
  if (currentRole === SUPPLIER) {
    const retailerId = retailer.id;
    supplierRetailer = supplier.supplier_retailers.find(
      (supplierRetailer) => supplierRetailer.retailer_id === retailerId,
    );
  }

  const isOperator = supplierRetailer?.retailer_type === retailerTypes.OPERATOR;
  const isRetailer = !isOperator;
  const isDropship = supplierRetailer?.order_type === orderTypes.DROPSHIP;
  const isMarketplace = !isDropship;

  const priceType = isMarketplace ? RETAIL_PRICE_COLUMN : UNIT_PRICE_COLUMN;

  return {
    isOperator,
    isRetailer,
    isDropship,
    isMarketplace,
    isSeller: isMarketplace,
    isVendor: isRetailer,
    priceType,
  };
}
